<template>
    <FilterAccordion
        :panel-id="'filter-field-' + formField.id"
        :title="formField.title"
        :expanded="isActive"
        :is-active="isActive"
    >
        <FormFieldRangeFilter
            v-if="formField.supports_range"
            :formField="formField"
            :onChangeHandler="onChangeHandler"
        />
        <FormFieldFilter
            v-else
            :formField="formField"
            :onChangeHandler="onChangeHandler"
            compact
        />
    </FilterAccordion>
</template>

<script>
import FilterAccordion from '../FilterAccordion.vue';
import FormFieldFilter from './FormFieldFilter.vue';
import FormFieldRangeFilter from './FormFieldRangeFilter.vue';

export default {
    name: 'FormFieldFilterAccordion',
    components: {FilterAccordion, FormFieldFilter, FormFieldRangeFilter},
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
